export default function stockItReducer(state = {
  stock_it: [],
  stock_it_objectives: [],
  meta: {products: []},
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_STOCK_IT_PENDING':
    case 'ADD_STOCK_IT_PENDING':
    case 'GET_STOCK_IT_META_PENDING':
    case 'GET_STOCK_IT_OBJECTIVES_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_STOCK_IT_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stock_it: action.payload.data
      };
    }
    case 'ADD_STOCK_IT_FULFILLED': {
      return {
        ...state
      };
    }
    case 'GET_STOCK_IT_META_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        meta: action.payload
      };
    }
    case 'GET_STOCK_IT_OBJECTIVES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stock_it_objectives: action.payload.data
      };
    }
    case 'GET_STOCK_IT_REJECTED':
    case 'ADD_STOCK_IT_REJECTED':
    case 'GET_STOCK_IT_META_REJECTED':
    case 'GET_STOCK_IT_OBJECTIVES_REJECTED': {
      return {...state};
    }
    default: {
      return {...state};
    }
  }
}
